import { WorkPlace as WorkPlaceResponse } from '@/DTOS/WorkPlace/Response/WorkPlace';
import { debounce } from 'lodash';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/WorkPlace/WorkPlaceModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import '../WorkPlaceTable/WorkPlaceTable.css';
import { WorkPlaceColumn } from './WorkPlaceColumn';

interface WorkPlaceTableProps {
  handleModalInformationOpen: (record: WorkPlaceResponse) => void;
}

const WorkPlaceTable: React.FC<WorkPlaceTableProps> = ({ handleModalInformationOpen }) => {
  const dispatch = useDispatch();

  const reduxWorkPlace = useSelector((state: RootState) => state?.models?.workPlace);
  const workPlaces = useSelector((state: RootState) => state?.store?.workPlace?.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxWorkPlace?.props?.skip / reduxWorkPlace?.props?.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = useCallback((record: any) => {
    window.open(`/administration/workPlace/edit?id=${record?.id}`, '_blank');
  }, []);

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxWorkPlace?.props?.take,
    total: reduxWorkPlace?.props?.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        allowClear
        onChange={handleSearch}
        defaultValue={reduxWorkPlace?.props?.searchTerm}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={workPlaces}
        pagination={paginationConfig}
        columns={WorkPlaceColumn(handleEdit, handleModalInformationOpen)}
        rowKey='id'
      />
    </>
  );
};

export default WorkPlaceTable;
